import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';
import { useLoginUserByFacebook } from './api/postLogonLoginFacebook';
import { useState } from 'react';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import ToastMessage from 'components/toastMessage';
import * as Styled from './authFacebookLogin.Styles';

export const AuthFacebookLogin = ({ url, onSuccess}) => {

  const [toastData, setToastData] = useState(null);
  const { mutate: login, isLoading: isLoggingIn } = useLoginUserByFacebook({url, onSuccess: () => {
    onSuccess();
  }});
  return (
    <Stack>
        <FacebookLogin
            appId={process.env.REACT_APP_FACEBOOK_APP_ID}            
            autoLoad={false}
            scope="public_profile, email"
            fields="name,email,picture"
            onClick={() => console.log("Facebook login clicked")}
            callback={response => {
                console.log(response);              
                login(response);               
              }}
              render={renderProps => (                
                <Styled.FacebookLogin onClick={renderProps.onClick}>Zaloguj się z Facebook</Styled.FacebookLogin>
              )}/>   
          {toastData && (
        <ToastMessage
          open
          onClose={() => setToastData(null)}
          severity={toastData.severity}
          message={toastData.message}
        />
      )}
    </Stack>
  );
};

GoogleLogin.propTypes = {
  onSuccess: PropTypes.func,
};
